import React from 'react';
import styled from 'styled-components';
import { Currency } from '@increasecard/typed-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const Title = styled.div`
  ${({ theme }) => theme.typography.inputLabel};
  font-weight: 500;
  margin-bottom: 4px;
`;
const Value = styled.div<Pick<InlineAmountProps, 'variant' | 'loading'>>`
  ${({ theme }) => theme.typography.H2}
  font-weight: bold;
  color: ${({ theme, variant }) => theme.colorsNew.product[variant]};
  transition: opacity 200ms ease-in-out;
  ${({ loading }) => loading && `opacity: 0.18;`}
`;

export interface InlineAmountProps {
  title: string;
  value: number;
  variant: 'dark70' | 'dark30';
  loading: boolean;
}

export function InlineAmount({ loading, title, value, variant }: InlineAmountProps) {
  return (
    <Wrapper>
      <Title>{title}</Title>
      <Value loading={loading} variant={variant}>
        <Currency currency="ARS" language={navigator.language} value={value} />
      </Value>
    </Wrapper>
  );
}
